import { INVOICE_SUMMARY, BILLING_INFORMATION } from './messages';
import { ASSET_SPECS, CUSTOMER_ATTRIBUTES, ASSET_LOCATION, LEASE_DETAILS, ASSET_DETAILS, INVOICE_DETAILS, BILLING_LOCATION } from './messages';

export interface ViewOptions {
  id: string;
  label: string;
}

export const assetViewOptions: ViewOptions[] = [
  { id: 'assetSpecs', label: ASSET_SPECS },
  { id: 'customerAttributes', label: CUSTOMER_ATTRIBUTES },
  { id: 'assetLocation', label: ASSET_LOCATION },
  { id: 'leaseDetails', label: LEASE_DETAILS },
];

export const invoiceViewOptions: ViewOptions[] = [
  { id: 'invoices', label: INVOICE_SUMMARY},
  { id: 'billingInfo', label: BILLING_INFORMATION}
];

export const invoiceAssetViewOptions: ViewOptions[] = [
  { id: 'assetDetails', label: ASSET_DETAILS },
  { id: 'invoiceDetails', label: INVOICE_DETAILS },
  { id: 'assetLocation', label: ASSET_LOCATION },
  { id: 'billingLocation', label: BILLING_LOCATION },
  { id: 'customerAttributes', label: CUSTOMER_ATTRIBUTES },
];